<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1">
<p class="titlepage">Ancient Battle Formations</p>
</a><a id="VPS-2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Half_title_page.vue?09c54723